module.exports = __webpack_public_path__ + "static/media/iot_device.1a3561ac.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/iot_device.jpg
// module id = 379
// module chunks = 0